import { render, staticRenderFns } from "./WalletTransfer.vue?vue&type=template&id=39e507f5&scoped=true"
import script from "./WalletTransfer.vue?vue&type=script&lang=js"
export * from "./WalletTransfer.vue?vue&type=script&lang=js"
import style0 from "./WalletTransfer.vue?vue&type=style&index=0&id=39e507f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e507f5",
  null
  
)

export default component.exports